import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ShiftService } from '../../Services/shift.service';
import { TokenEncryptionService } from '../../Services/token-encryption.service';
import { DeleteShiftDialogComponent } from '../delete-shift-dialog/delete-shift-dialog.component';
import swal from 'sweetalert2';

export interface ShiftReductionDialogData {}

export interface ShiftReductionDialogResult {
  success: boolean;
}

@Component({
  selector: 'app-shift-reduction-dialog',
  templateUrl: './shift-reduction-dialog.component.html',
  styleUrls: ['./shift-reduction-dialog.component.css'],
  standalone: false
})
export class ShiftReductionDialogComponent implements OnInit {

  shifts: any[] = [];
  loading = true;
  hasDeleted = false;

  constructor(
    public dialogRef: MatDialogRef<ShiftReductionDialogComponent, ShiftReductionDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ShiftReductionDialogData,
    private shiftService: ShiftService,
    private tokenEncryptionService: TokenEncryptionService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.fetchShifts();
  }

  fetchShifts(): void {
    this.loading = true;
    const user = this.tokenEncryptionService.getEncryptedItem<any>('user');
    const loggedInUser = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser');
    const companyId = loggedInUser?.company_id ?? user?.company_id ?? user?.id ?? 0;
    
    this.shiftService.getShifts(companyId).subscribe({
      next: (shifts: any) => {
        this.shifts = shifts || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        swal.fire('Error', 'Failed to load shifts', 'error');
      }
    });
  }

  onDeleteShift(shift: any): void {
    const dialogRef = this.dialog.open(DeleteShiftDialogComponent, {
      width: '400px',
      data: { shift: shift },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.hasDeleted = true;
        this.fetchShifts(); // reload shifts
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close({ success: this.hasDeleted });
  }
}
